import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
import(/* webpackMode: "eager" */ "/app/src/components/pages/wallet/WalletBenefits.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/pages/wallet/WalletFinalCTA.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/pages/wallet/WalletHero.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/pages/wallet/WalletHowItWorks.tsx")